import { BillRepository } from "../repositories/BillRepository";
import { BillsResultEntity } from "../entities/BillListItemEntity";

export class GetBillsForVendorUseCase {
  constructor(private repository: BillRepository) {}

  async execute(
    vendorZohoId: string,
    limit?: number,
    offset?: number,
    search?: string
  ): Promise<BillsResultEntity> {
    // Validate Zoho vendor ID
    if (!vendorZohoId || vendorZohoId.trim() === "") {
      throw new Error("Vendor ID is required");
    }

    // Validate pagination parameters
    if (limit !== undefined && (limit < 1 || limit > 100)) {
      throw new Error("Limit must be between 1 and 100");
    }

    if (offset !== undefined && offset < 0) {
      throw new Error("Offset must be 0 or greater");
    }

    // Execute repository call
    return await this.repository.getBillsForVendor(
      vendorZohoId.trim(),
      limit,
      offset,
      search?.trim()
    );
  }
}

